import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const usePaymentMethods = (studentId) => {
    const {
        isLoading, data: paymentMethods, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: ["student/paymentmethods", studentId],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/paymentmethods`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        enabled: !!studentId,
    });

    return {
        isLoading,
        isRefetching,
        paymentMethods,
        error,
        refetch,
    };
};
